import React from 'react';
import { Component } from 'react';

export default class ServicoGeralTurissul extends Component {

    render() {
        return (
            <>
                <div className="menu-accordion-heading">
                    <a className="menu-accordion-toggle" href="#item-compra-7">
                        Geral
                        <i className="fa fa-caret-down p-float-right"></i>
                    </a>
                </div>
                <div id="item-compra-7" className="menu-accordion-body"
                    style={{ overFlow: 'hidden', display: 'none' }}>
                    <div className="menu-accordion-inner">
                        <h3 className="menu-accordion-inner-trigger js-accordion-inner-trigger">
                            Preciso chegar com antecedência?
                            <i className="fa fa-caret-down p-float-right"></i>
                        </h3>
                        <div className="menu-accordion-inner-collapse">
                            <p>Sim. É obrigatório chegar com <b>pelo menos 30 minutos de antecedência</b> para garantir um embarque tranquilo e evitar imprevistos.</p>
                        </div>
                        <h3 className="menu-accordion-inner-trigger js-accordion-inner-trigger">
                            Tenho direito a reembolso caso perca a viagem?
                            <i className="fa fa-caret-down p-float-right"></i>
                        </h3>
                        <div className="menu-accordion-inner-collapse">
                            <p><b>Não.</b></p>
                            <p>Em caso de não comparecimento para o embarque, o passageiro poderá solicitar a <b>remarcação da passagem dentro do prazo permitido</b>, porém não haverá reembolso pelo não comparecimento.</p>
                        </div>
                        <h3 className="menu-accordion-inner-trigger js-accordion-inner-trigger">
                            Posso cancelar minha passagem e solicitar reembolso?
                            <i className="fa fa-caret-down p-float-right"></i>
                        </h3>
                        <div className="menu-accordion-inner-collapse">
                            <p>Sim. O cancelamento e a solicitação de reembolso podem ser realizados com <b>até 3 horas de antecedência do horário de embarque</b>.</p>
                            <p>A solicitação deve ser feita: <br/> 
                                <span style={{'padding-left': '5px'}}><b>• pela mesma plataforma onde a compra foi realizada</b></span>.</p>
                        </div>
                        <h3 className="menu-accordion-inner-trigger js-accordion-inner-trigger">
                            Posso transferir minha passagem para outra pessoa?
                            <i className="fa fa-caret-down p-float-right"></i>
                        </h3>
                        <div className="menu-accordion-inner-collapse">
                            <p>Não.</p>
                            <p>A passagem é <b>nominal e intransferível</b>. No momento do embarque, é obrigatória a apresentação de documento de identificação do passageiro.</p>
                        </div>
                        <h3 className="menu-accordion-inner-trigger js-accordion-inner-trigger">
                            Posso remarcar minha passagem?
                            <i className="fa fa-caret-down p-float-right"></i>
                        </h3>
                        <div className="menu-accordion-inner-collapse">
                            <p>Sim.</p>
                            <p>A remarcação pode ser realizada:</p>
                            <p style={{'padding-left': '5px'}}>• <b>Até 3 horas antes da viagem</b>: sem custos;</p>
                            <p style={{'padding-left': '5px'}}>• Após esse prazo: poderá haver cobrança de taxa.</p>
                            <p>As passagens possuem validade de até <b>1 ano</b>, conforme as normas aplicáveis ao transporte rodoviário.</p>
                        </div>

                    </div>
                </div>
            </>
        )
    }
}